import React, { ReactElement, useState, ChangeEvent } from 'react';
import useParseActionRouteParams from 'hooks/route-action/use-parse-action-route-params';
import { useTranslation } from 'react-i18next';
import PrintModal from '../../components/PrintModal';
import Dropdown, { DropdownOption } from 'components/@common/Inputs/Dropdown';
import { buildSearchQueryParams } from 'utilities/query-params-util';
import { Certificates } from 'types/enums';

const PrintCertificatesCardsModal = (): ReactElement | null => {
  const { t } = useTranslation('PrintCertificatesCardsModal');
  const { classroomId } = useParseActionRouteParams<{ classroomId: string }>();
  const [selected, setSelected] = useState('');

  const certificatesOptions: DropdownOption[] = [
    { label: 'Keyboarding Without Tears Completion Certificate', value: Certificates.KWT },
    { label: 'Digital Citizenship Completion Certificate', value: Certificates.DC }
  ];

  const handleChange = (evt: ChangeEvent<any>): void => {
    setSelected(evt.target?.value || '');
  };

  const handleOnPrint = (): void => {
    window.open(
      `/print-screen/certificates${buildSearchQueryParams({
        classroomId: +classroomId,
        certificateType: selected
      })}`
    );
  };

  return (
    <PrintModal
      title={t('Print Student Certificates')}
      onPrint={handleOnPrint}
      options={{ printText: t('Print Certificates'), disablePrintButton: !selected }}
    >
      <Dropdown
        id="print-certificates-cards"
        options={certificatesOptions}
        handleChange={handleChange}
        label={t('Select Certificate')}
        value={selected}
      />
    </PrintModal>
  );
};

export default PrintCertificatesCardsModal;
